import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { Modulo } from "@/types/api";

export function useModuli() {
  return useQuery({
    queryKey: ["moduli"],
    queryFn: () => apiFetch<Modulo[]>("/api/v1/moduli"),
    staleTime: 5 * 60_000,
  });
}
